module.exports = __webpack_public_path__ + "media/images/icons/twotone/copyright-circle-e8a6043dd6b9a8126a737acd291b35cb.svg";